import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
//import './assets/style/style.scss';
import './assets/style/style.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";   
import { AppToast } from './lib/toast';   
import {
  BrowserRouter,
} from "react-router-dom";
import { Routing } from './routing';
import { Provider } from 'react-redux'
import { rdxStore } from './store/store';

function App() {
  return (
    <BrowserRouter>
      <div className="App rc_app">
        <Provider store={rdxStore}>
          <Routing />
        </Provider>
      </div>
      <AppToast.AppToastContainer />
    </BrowserRouter>
  );
}

export default App;
